//const baseURL = window.location.origin.replace("8080", "8000");
const baseURL = "http://demo.kindimglueck.crowns-media.com";
const endpoint = baseURL + "/fetch";

import { Editor } from "tiptap";
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
  TableCell,
  Table,
  TableRow,
  TableHeader
} from "tiptap-extensions";

export default {
  computed: {
    baseURL() {
      return baseURL;
    },
    endpoint() {
      return endpoint;
    }
  },

  methods: {
    isPreview() {
      if (window.parent && window.parent.Statamic) return true;
    },

    $asset(config, fn) {
      typeof config === "string" && (config = { src: config });
      Array.isArray(config.src) && (config.src = config.src[0]);

      config = config || {};

      if (!config.src || config.src.length === 0) {
        fn(null);
        return;
      }

      var args =
        config.src.indexOf("assets::") >= 0
          ? "src=" + config.src
          : "src=/assets/" + config.src;
      args += config.w ? "&w=" + config.w : "";
      args += config.h ? "&h=" + config.h : "";
      args += config.fit ? "&fit=" + config.fit : "";

      return $.getJSON(endpoint + "/asset?" + args, response => {
        response.src = baseURL + response.src;
        fn(response.src ? response : null);
      });
    },

    $uri(uri, fn) {
      if (window.parent && window.parent.Statamic) {
        return fn(window.parent.Statamic.$app.$store.state.publish.base.values);
      }

      uri = uri.startsWith("/") ? uri : "/" + uri;
      return $.getJSON(endpoint + "?filter[uri:equals]=" + uri, response => {
        response.length > 0 ? fn(response[0]) : fn(null);
      });
    },

    $structure(config, fn) {
      typeof config === "string" && (config = { handle: config });

      var args = "handle=" + config.handle;
      args += config.includeHome ? "&include_home=true" : "";

      return $.getJSON(endpoint + "/structure?" + args, fn);
    },

    $entries(ids, fn) {
      if (!ids.length) return null;

      var args = "ids=" + ids.toString();

      return $.getJSON(endpoint + "/entries?" + args, fn);
    },

    $id(id, fn) {
      return $.getJSON(endpoint + "/entries?ids=" + id, response => {
        fn(response[0]);
      });
    },

    $bard(content) {
      window._editor = window._editor
        ? window._editor
        : new Editor({
            extensions: [
              new Blockquote(),
              new CodeBlock(),
              new HardBreak(),
              new Heading({ levels: [1, 2, 3] }),
              new BulletList(),
              new OrderedList(),
              new ListItem(),
              new TodoItem(),
              new TodoList(),
              new Bold(),
              new Code(),
              new Italic(),
              new Strike(),
              new Underline(),
              //new History(),
              new Table(),
              new TableHeader(),
              new TableRow(),
              new TableCell(),
              new Link()
            ]
          });
      console.log("editor");
      console.log(window._editor);
      window._editor.setContent({
        type: "doc",
        content: content
      });
      return window._editor.getHTML();
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/api.js